import React from "react";
import { Backdrop, CircularProgress, Typography } from "@mui/material";
import { translationService } from "../../services/translation/TranslationService";

interface SavingBackdropProps {
  open: boolean;
  /** Translation key for the line under the spinner. */
  messageKey?: string;
}

/**
 * Holds the whole screen while a list is being saved.
 *
 * A save is a write, a re-read, and then the sign-off with its own re-read -- several seconds on a
 * long list. Left clickable, the reviewer could edit rows the reload is about to replace, switch
 * tabs or files under it, or press Save a second time. Blocking is the honest signal that the page
 * is busy, and the message keeps "busy" from looking like "stuck".
 *
 * Kept out of the PDF capture: html2canvas reads the live DOM.
 */
const SavingBackdrop: React.FC<SavingBackdropProps> = ({
  open,
  messageKey = "comparison.approved-list.saving",
}) => (
  <Backdrop
    open={open}
    data-html2canvas-ignore
    sx={{
      position: "fixed",
      zIndex: (theme) => theme.zIndex.modal + 1,
      color: "#fff",
      flexDirection: "column",
      gap: 2,
    }}
  >
    <CircularProgress color="inherit" />
    <Typography variant="body2">{translationService.translate(messageKey)}</Typography>
  </Backdrop>
);

export default SavingBackdrop;
